<template>
    <!-- 大排名 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">大排名</div> -->
        <div style="height:auto;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col>

                    <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" :clearable="false"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button>
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="大排名报表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>
            </div>

            <div style="margin: 10px 3% 0px;overflow-y:hidden;overflow-x: auto;">
                <div style="height: 370px;min-width: 1538px;border:1px solid #ccc;">
                    <div style="width: 60%;height: 370px;float: left;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>各项指标统计表 </span>
                        </div>
                        <div style="text-align: right;margin-right:50px;font-size: 14px;position: relative;top:12px;">
                            <span>单位:元 </span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main1">
                        </div>
                    </div>
                    <div style="width: 39%;height: 370px;float: right;">
                        <div style="width: 96%;height: 370px;" id="main2">
                        </div>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="架构">
                        </el-table-column>
                        <el-table-column align="center" label="各指标项">
                            <el-table-column prop="wages_payable" align="center" label="工资应发"></el-table-column>
                            <el-table-column prop="employer_insurance_deduction" align="center" label="雇主险扣费">
                            </el-table-column>
                            <el-table-column prop="paid_wages" align="center" label="工资实发"></el-table-column>
                            <el-table-column prop="timeliness_entry" align="center" label="入职及时率"></el-table-column>
                            <el-table-column prop="timely_turnover_rate" align="center" label="离职及时率"></el-table-column>
                            <el-table-column prop="timeliness_bank_number" align="center" label="银行卡号及时性">
                            </el-table-column>
                            <el-table-column prop="accuracy_bank_number" align="center" label="银行卡号准确率">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {

            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            tableDatas: [],
            //条件
            condition: {
                data: "",
            },

            //组织架构数据
            organizeList: [],

            //页面相关
            dialogVisible: false,

            condition: {
                years_date: this.$globals.getNowTimes(),
                organize_ids: [],
            },



            download_excel: {
                "架构": "organize_name",
                "各指标项 - 工资应发": "wages_payable",
                "各指标项 - 雇主险扣费": "employer_insurance_deduction",
                "各指标项 - 工资实发": "paid_wages",
                "各指标项 - 入职及时率": "timeliness_entry",
                "各指标项 - 离职及时率": "timely_turnover_rate",
                "各指标项 - 银行卡号及时性": "timeliness_bank_number",
                "各指标项 - 银行卡号准确率": "accuracy_bank_number",
            },


            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },

        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },

        //图表
        async Find_Tu() {
            var url = "reportBigRanking/getReport";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.chart = data;
                    if (data == null) {
                        this.chart = {
                            wages_payable: "",
                            employer_insurance_deduction: "",
                            paid_wages: "",
                            timeliness_entry: "0",
                            timely_turnover_rate: "0"
                        }
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }

            echarts.init(document.getElementById('main1')).setOption({
                grid: {
                    top: '40px',
                    left: '90px',
                    right: '40px',
                    bottom: '90px'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['工资应发', '雇主险扣费', '工资实发']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [this.chart.wages_payable, this.chart.employer_insurance_deduction, this.chart.paid_wages],
                    type: 'bar',
                    barWidth: '20%',
                    color: '#147AFF',

                }]
            })
            echarts.init(document.getElementById('main2')).setOption({
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 80,
                    top: 190,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A'],
                series: [{
                    data: [
                        { value: this.chart.timeliness_entry == null ? "0" : this.chart.timeliness_entry, name: '入职及时率' },
                        { value: this.chart.timely_turnover_rate== null ? "0" : this.chart.timely_turnover_rate, name: '离职及时率' }
                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['35%', '60%'],
                }]
            })
        },
        //查询
        async Find() {
            this.Find_Tu();
            var url = "reportBigRanking/selectReportBigRanking";
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                years_date: this.condition.years_date + '-01',
                organizeIds_num: this.condition.organize_ids[this.condition.organize_ids.length - 1],
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },

        async Update() {
            var url = "reportBigRanking/refreshReportBigRanking";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                if (code === '200') {
                    this.tableData = [];
                    this.page_num = 1;
                    this.page_size = 10;
                    this.total = 0;
                    this.$message.success("更新成功");
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },

        //导表
        async ExportForm() {

            var url = "reportBigRanking/selectReportBigRanking";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data.list;
                    this.total = data.total;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },

        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        },
    },
    async created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// big_ranking.vue?1813e120